import { EmailStatus, RewardStatus } from '../../models/engage/CampaignRecipients.model';

export class DataTableConstants {
  public static get mobileTitle(): string {
    return 'title';
  }

  public static get mobileSubtitle(): string {
    return 'subtitle';
  }

  public static get defaultPageSize(): number {
    return 20;
  }

  public static get f2SToolTipText(): string {
    return 'Forgot2Scan captures transactions in which customers did not scan or mobile order but manually submit ' +
           'their receipt for points via app or website.';
  }

  public static get statusMap() {
    let statusMap = {};
    statusMap[RewardStatus.RedeemedIssuedLocation] = 1;
    statusMap[RewardStatus.Loaded] = 1.1;
    statusMap[RewardStatus.RedeemedOtherLocation] = 1.2;
    statusMap[EmailStatus.Opened] = 1;
    statusMap[EmailStatus.Delivered] = 1.1;
    statusMap[EmailStatus.Sent] = 1.2;
    statusMap['Completed'] = 1.5;
    statusMap[RewardStatus.DuplicateRewardExclusion] = 2
    statusMap[RewardStatus.LocationRewardExclusion] = 2.1
    statusMap[EmailStatus.Spam] = 2
    statusMap[EmailStatus.Unsubscribed] = 2.1
    statusMap[EmailStatus.Dropped] = 2.2
    statusMap[EmailStatus.NotAttempted] = 2.3
    statusMap[RewardStatus.Failed] = 3
    statusMap[EmailStatus.Failed] = 3
    statusMap[EmailStatus.FailedProcessing] = 3
    statusMap['Failed'] = 3
    statusMap['Pending'] = 4
    return statusMap
  }

  public static get statusIcon() {
    return {
      'completed' : 'https://www.cfacdn.com/img/Spotlight/Icons/StatusCompleteIcon.png',
      'failure' : 'https://www.cfacdn.com/img/Spotlight/Icons/FailedIcon.png',
      'pending' : 'https://www.cfacdn.com/img/Spotlight/Icons/PendingIcon.png',
      'info' : 'https://www.cfacdn.com/img/Spotlight/Icons/Info.svg',
    };
  }

  public static get statusIconInfo() {
    return {
      'completed' : 'Completed',
      'failure' : 'Failed',
      'pending' : 'Scheduled'
    };
  }
}
